<script setup lang="ts">
    import { ICoachingFormQuestion } from '@/js/services/api/coachingForm/types';
    import { temporaryUUID } from '@/js/composables/useTemporaryUUID';
    import { useEditCoachingFormStore } from '@/js/stores/edit-coaching-form';
    import { onMounted } from 'vue';
    import EditCoachingFormAnswerOptions from './EditCoachingFormAnswerOptions.vue';

    const props = defineProps<{
        question: ICoachingFormQuestion;
    }>();

    const { addAnswer } = useEditCoachingFormStore();

    onMounted(() => {
        if (props.question.answers.length === 0) {
            addAnswer(props.question, { id: temporaryUUID(), label: 'Ja', points: 5 });
            addAnswer(props.question, {
                id: temporaryUUID(),
                label: 'Nej',
                points: 0,
            });
        }
    });
</script>

<template>
    <fieldset class="block mt-6">
        <EditCoachingFormAnswerOptions :question="question" />
    </fieldset>
</template>
